var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorporateAccountManager(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5C10.6739 2.5 9.40215 3.02678 8.46447 3.96447C7.52678 4.90215 7 6.17392 7 7.5C7 8.82608 7.52678 10.0979 8.46447 11.0355C9.40215 11.9732 10.6739 12.5 12 12.5C13.3261 12.5 14.5979 11.9732 15.5355 11.0355C16.4732 10.0979 17 8.82608 17 7.5C17 6.17392 16.4732 4.90215 15.5355 3.96447C14.5979 3.02678 13.3261 2.5 12 2.5Z",
    stroke: "#76BC21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1552 18.106V14.0229H10.8452V18.3706L11.9372 19.336L13.1552 18.106Z",
    stroke: "#76BC21",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00024 13.5C7.33724 13.5 5.73824 14.258 4.80124 15.4C4.32624 15.98 3.99124 16.697 3.96224 17.492C3.93224 18.304 4.19724 20.408 4.80224 21.1C6.27324 22.784 8.65224 22.5 12.0002 22.5C15.3472 22.5 17.4812 22.784 18.9542 21.1C19.5582 20.408 20.0682 18.304 20.0382 17.492C20.0082 16.697 19.6742 15.98 19.1982 15.4C18.2632 14.258 16.6642 13.5 15.0002 13.5H9.00024Z",
    stroke: "#76BC21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateAccountManager);
export default __webpack_public_path__ + "static/media/corporateAccountManager.162c397104f33f62273af6d8d98e8207.svg";
export { ForwardRef as ReactComponent };